/* 三國逗陣打 · 電腦武將 AI
 * 決策每 0.25 秒一次（撤退／交戰／打野／清兵／推塔／攻本營），輸出的是和玩家相同的指令：
 * moveTo、target、skill{i,x,y}。技能會預判目標走位，但故意留一點誤差。 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from './sg.ts';

const M = SG.MAP;
const gd = (a, b) => SG.gd(a.x, a.y, b.x, b.y);
// 沿著路線往敵方本營推進了多遠
const PROGRESS = (team, lane, o) => { const s = M.laneS(lane, o.x, o.y); return team === 0 ? s : M.laneLen[lane] - s; };
const back = (team, lane, o, d) => M.laneAt(lane, M.laneS(lane, o.x, o.y) + (team === 0 ? -d : d));

// ---------- 分路（v0.5.1：照定位補位）----------
// 五個位置：上路、中路、游擊（打黃巾）、下路主（射手）、下路副（輔助）；ROLE_FIT 是定位適合各位置的程度（沒列的 1 分）
const SLOT_LANE = { top: 'top', mid: 'mid', jungle: 'jungle', botC: 'bot', botS: 'bot' };
const ROLE_FIT = {
  top: { 坦克: 3, 戰士: 3, 先鋒: 2 },
  mid: { 法師: 3, 刺客: 3, 指揮: 2 },
  jungle: { 戰士: 3, 刺客: 3, 先鋒: 2 },
  botC: { 射手: 3, 法師: 2 },
  botS: { 輔助: 3, 指揮: 3, 法師: 2, 坦克: 2 },
};
const fit = (spec, slot) => Math.max(ROLE_FIT[slot][spec.role] || 1, (spec.role2 && ROLE_FIT[slot][spec.role2]) || 1);
// 這一場開著的位置：路沒開就沒有那個位置；游擊只有一隊 5 人才有（官渡 3v3、長坂坡 1v1 不打野）
const slotsOf = (w, n) => { const lanes = w.lanes || ['top', 'mid', 'bot']; return Object.keys(SLOT_LANE).filter((k) => (k === 'jungle' ? n >= 5 : lanes.includes(SLOT_LANE[k]))); };
// 把 hs 分到 free 這些位置，總分最高；人比位置多時，多出來的照開著的路輪流補（0 分）
function bestFill(w, hs, free) {
  const lanes = w.lanes || ['top', 'mid', 'bot'];
  const pool = free.slice();
  for (let i = 0; pool.length < hs.length; i++) pool.push('x:' + lanes[i % lanes.length]);
  let best = null, bs = -1;
  const pick = (i, used, cur, sc) => {
    if (i === hs.length) { if (sc > bs) { bs = sc; best = cur.slice(); } return; }
    for (let j = 0; j < pool.length; j++) {
      if (used & (1 << j)) continue;
      cur[i] = pool[j];
      pick(i + 1, used | (1 << j), cur, sc + (pool[j].startsWith('x:') ? 0 : fit(hs[i].spec, pool[j])));
    }
  };
  pick(0, 0, [], 0);
  return best || [];
}
const laneOfSlot = (slot) => (slot.startsWith('x:') ? slot.slice(2) : SLOT_LANE[slot]);
// 真人佔的位置：走下路時，射手算下路主，其他算下路副
function humanSlot(h, lane) {
  if (lane !== 'bot') return lane;
  return fit(h.spec, 'botC') >= fit(h.spec, 'botS') ? 'botC' : 'botS';
}
// 一隊重新分路：真人的位置固定，電腦分剩下的
function fillTeam(w, team, humanLane) {
  const hs = w.heroes(team), slots = slotsOf(w, hs.length);
  const humans = hs.filter((h) => h.human), bots = hs.filter((h) => !h.human);
  const taken = [];
  for (const h of humans) {
    const sl = humanLane(h);
    if (sl && slots.includes(sl) && !taken.includes(sl)) taken.push(sl);
  }
  const plan = bestFill(w, bots, slots.filter((k) => !taken.includes(k)));
  return bots.map((h, i) => [h, plan[i]]);
}

function assign(w) {
  for (let team = 0; team < 2; team++) {
    // 開局：真人還沒走，先假設他會去自己定位最適合的位置
    const slots = slotsOf(w, w.heroes(team).length);
    const guess = (h) => slots.slice().sort((a, b) => fit(h.spec, b) - fit(h.spec, a))[0];
    // 合作模式的難度只影響對面（魏軍）的電腦：出手準度與基礎數值
    const D = w.rules && w.rules.diff && team === 1 ? { easy: [0.3, 0.2, 0.85], hard: [0.85, 0.15, 1.15] }[w.rules.diff] : null;
    for (const [h, slot] of fillTeam(w, team, guess)) {
      h.ai = { lane: laneOfSlot(slot), slot, mode: 'move', t: SG.rand() * 0.3, goal: null, target: null, tp: null, tv: [0, 0], skill: D ? D[0] + SG.rand() * D[1] : 0.6 + SG.rand() * 0.3 };
      if (D && D[2] !== 1) { h.diffMul = D[2]; w.recalc(h, true); }
    }
  }
}

// 遊戲中補位：真人在某一路（或野區）待滿 FILL_STAY 秒，而那裡已經有電腦，就重新分路（每隊冷卻 FILL_CD 秒，只在前 FILL_UNTIL 秒）
const FILL_STAY = 15, FILL_CD = 60, FILL_UNTIL = 600;
function whereIs(h) {
  if (Math.hypot(h.x - M.bases[h.team].x, h.y - M.bases[h.team].y) < M.shopR + 200) return null; // 在本營不算
  const lane = M.laneNear(h.x, h.y), p = M.laneAt(lane, M.laneS(lane, h.x, h.y));
  return Math.hypot(p[0] - h.x, p[1] - h.y) > 420 ? 'jungle' : lane;
}
function refill(w) {
  if (w.t > FILL_UNTIL) return;
  for (let team = 0; team < 2; team++) {
    const hs = w.heroes(team), humans = hs.filter((h) => h.human), bots = hs.filter((h) => !h.human && h.ai);
    if (!humans.length || !bots.length) continue;
    for (const h of humans) {
      const at = whereIs(h);
      if (at !== h.fillAt) { h.fillAt = at; h.fillSince = w.t; }
    }
    if ((w.fillCd && w.fillCd[team]) > w.t) continue;
    const settled = humans.filter((h) => h.alive && h.fillAt && w.t - h.fillSince >= FILL_STAY);
    // 有電腦跟真人擠在同一個位置才換（同一路但真人是下路主、電腦是下路副就不算擠）
    const clash = settled.some((h) => { const sl = humanSlot(h, h.fillAt); return bots.some((b) => b.ai.slot === sl); });
    if (!clash) continue;
    const lane = (h) => (settled.includes(h) ? humanSlot(h, h.fillAt) : null);
    for (const [b, slot] of fillTeam(w, team, lane)) { if (b.ai.slot !== slot) { b.ai.slot = slot; b.ai.lane = laneOfSlot(slot); b.ai.goal = null; } }
    (w.fillCd || (w.fillCd = [0, 0]))[team] = w.t + FILL_CD;
  }
}

function useful(w, u, i, t) {
  if (t && t.kind === 'seal') return false; // 玉璽只吃普攻，技能別浪費
  const sk = SG.skillAt(u, i);
  if (i === 3 && u.stolen && u.stolen.until > w.t && u.st.silence <= 0) return !!t && t.kind === 'hero' && SG.gd(u.x, u.y, t.x, t.y) < 650; // 曹丕「受禪」奪來的大招
  if (!sk || sk.passive || !u.skillLv[i] || u.cd[i] > 0 || u.mp < w.skillCost(i, u.skillLv[i], sk) || u.st.silence > 0) return false;
  if (sk.hpCost && i !== 3 && u.hp / u.maxHp < 0.25) return false; // 耗血招：殘血不放（大招除外）
  if (SG.aiUseful) { const r = SG.aiUseful(w, u, i, t, sk); if (r !== undefined) return r; } // 武將檔的 ai／aiSig 自己決定（core/passives.ts）
  const hpR = u.hp / u.maxHp;
  if (sk.arch === 'heal') return hpR < 0.6 || w.alliesNear(u, 330).some((a) => a.kind === 'hero' && a.hp / a.maxHp < 0.5);
  if (sk.arch === 'shield') return !!t && hpR < 0.8;
  if (sk.arch === 'stealth') return false;
  const xk = sk.x && sk.x.k, lv = u.skillLv[i];
  if (xk) {
    const RR = w.skillRange(sk, lv) || 500;
    const low = (p) => w.units.some((a) => a.alive && a.team === u.team && a.kind === 'hero' && a.hp / a.maxHp < p && gd(u, a) < RR + 60);
    if (xk === 'fullheal') return low(0.3);
    if (xk === 'healwave') return low(0.6);
    if (xk === 'nuke' && sk.x.heal && low(0.55)) return true;
    if (xk === 'pullally') return hpR > 0.5 && w.units.some((a) => a.alive && a.team === u.team && a.kind === 'hero' && a !== u && a.hp / a.maxHp < 0.3 && gd(u, a) > 500 && a.dmgBy && Object.values(a.dmgBy).some((v) => v > w.t - 3));
    if (xk === 'vision' || xk === 'blink') return false;
    if (xk === 'feast') return w.units.some((a) => a.alive && a.owner === u && a.summon && gd(u, a) < 400) && (sk.x.atkP ? !!t && t.kind === 'hero' : hpR < 0.5);
    if (xk === 'zone' && sk.x.healP) return low(0.6);
    if (xk === 'buff' && !/^foes/.test(sk.x.to || '')) return !!t && (t.kind === 'hero' || t.kind === 'boss') && gd(u, t) < (sk.x.to ? 800 : 420);
    if (xk === 'summon') return !!t && gd(u, t) < 520 && (t.kind === 'hero' || (u.maxMp ? u.mp / u.maxMp : 1) > 0.6);
  }
  if (!t) return false;
  const hero = t.kind === 'hero' || t.kind === 'boss';
  if (!hero && (i === 3 || (u.maxMp ? u.mp / u.maxMp : 1) < 0.7)) return false;
  if (i === 3 && hero && t.hp / t.maxHp > 0.75 && w.enemiesNear(u, u.x, u.y, 400).filter((e) => e.kind === 'hero').length < 2) return false;
  const d = gd(u, t), R = w.skillRange(sk, u.skillLv[i]);
  // 控制技接在隊友的控制之後：目標還被控著就先別放，避免重疊浪費
  const cc = SG.ccOf(sk, u.skillLv[i]);
  if (hero && cc && SG.HARD_CC.some((k) => cc[k]) && w.hardCC(t) && (t.st.stun > 0.35 || t.st.root > 0.35 || t.st.knockup > 0.25)) return false;
  if (xk) {
    if (sk.x.noHero) return !hero && d < R + 60;
    const A = SG.aimOf(sk, lv);
    if (xk === 'buff') return d < 900;
    return A.kind === 'self' ? d < Math.max(120, (A.area || 200) * 0.8) : d < R * 0.95 + 40;
  }
  switch (sk.arch) {
    case 'bolt': case 'crescent': return d < R * 0.9;
    case 'hook': return d > 60 && d < 310;
    case 'charge': return d < 230;
    case 'dash': return d < 160;
    case 'spikes': return d > 30 && d < 240;
    case 'fire': return d > 60 && d < 270;
    case 'roar': return d < 260;
    case 'multi': case 'spin': return d < 120;
    case 'thunder': case 'volley': return d < 500;
    case 'trap': return d < 360;
    case 'slam': return d < 290;
    case 'blink': return d > 160 && d < 300;
    case 'summon': return d < 400;
    default: return hero; // buff、command：交戰時就放
  }
}

function shop(w, u) {
  // 木頭夠就叫投石車或衝車幫忙拆塔（留一點錢買裝備）
  if ((u.wood || 0) >= 20 && u.gold >= 900 && w.t > 240) w.buy(u, 'catapult');
  else if ((u.wood || 0) >= 30 && u.gold >= 1400) w.buy(u, 'reinforce');
  const r = SG.nextRecBuy(w, u);
  if (r.buy) w.buy(u, r.buy);
}
// 推薦出裝的下一步（電腦與玩家的「一鍵買推薦」共用）：{ next 下一件推薦成品, buy 現在買得起的那一件（成品或還缺的零件）}
// 這件（或已經合成進更高層的成品裡）是不是已經有了：v0.3.6 四層合成，合成倚天劍之後不要再回頭買七星寶刀
SG.buildTree = (id) => { const it = SG.ITEM[id]; return [id].concat(...(it && it.from ? it.from.map(SG.buildTree) : [])); };
SG.hasBuilt = (u, id) => u.items.some((x) => x && SG.buildTree(x.id).includes(id));
// 現在該買哪一件才能往 id 前進：買得起成品就買成品；不然一路往下找還缺、而且買得起的零件
SG.stepToward = function (w, u, id, depth) {
  const it = SG.ITEM[id];
  if (!w.canBuy(u, it)) return id;
  if (!it.from || (depth || 0) > 4) return null;
  const have = u.items.map((x) => x && x.id);
  for (const f of it.from) {
    const i = have.indexOf(f);
    if (i >= 0) { have[i] = null; continue; } // 這個零件已經有了
    const r = SG.stepToward(w, u, f, (depth || 0) + 1);
    if (r) return r;
  }
  return null;
};
// 只加氣、回氣的裝備（能武將買了沒用）
SG.manaOnly = (it) => Object.keys(it.stats).every((k) => k === 'mp') && (!it.fx || Object.keys(it.fx).every((k) => k === 'mregen'));
SG.nextRecBuy = function (w, u) {
  const list = SG.recOf(u.spec);
  for (const id of list) {
    const it = SG.ITEM[id];
    if (SG.hasBuilt(u, id)) continue;
    if (it.ranged && !u.ranged) continue;
    if ((SG.isNeng(u) || SG.noRes(u)) && SG.manaOnly(it)) continue; // 能、不耗資源：加氣、回氣對他沒用
    // 格子快滿了就只買成品或能合成的（不再塞新的基本裝）
    const free = u.items.filter((x) => x === null).length;
    const buy = SG.stepToward(w, u, id);
    if (buy && (free >= 2 || buy === id || SG.ITEM[buy].from)) return { next: id, buy };
    return { next: id, buy: null };
  }
  return { next: null, buy: null };
};

function laneFront(w, u, lane) {
  const mine = w.units.filter((m) => m.alive && m.kind === 'minion' && m.team === u.team && m.lane === lane);
  if (mine.length) {
    const lead = mine.reduce((a, b) => (PROGRESS(u.team, lane, b) > PROGRESS(u.team, lane, a) ? b : a));
    return back(u.team, lane, lead, 110);
  }
  const towers = w.units.filter((t) => t.kind === 'tower' && t.alive && t.team === u.team && t.lane === lane);
  if (towers.length) { const t = towers.reduce((a, b) => (PROGRESS(u.team, lane, b) > PROGRESS(u.team, lane, a) ? b : a)); return back(u.team, lane, t, -80); }
  return M.laneAt(lane, u.team === 0 ? 300 : M.laneLen[lane] - 300);
}
function underEnemyTower(w, u, x, y) {
  return w.units.find((t) => t.structure && t.alive && t.team !== u.team && t.team < 2 && SG.gd(t.x, t.y, x, y) < t.range + 40);
}

function decide(w, u) {
  const ai = u.ai, hpR = u.hp / u.maxHp, base = M.bases[u.team];
  if (SG.aiMoulue) SG.aiMoulue(w, u); // 謀略（moulue.ts）
  const atBase = Math.hypot(u.x - base.x, u.y - base.y) < M.shopR;
  if (atBase || M.shopAt(u.x, u.y)) shop(w, u); // 路過神秘商店、長江商船也順手補裝
  const retreat = () => { ai.mode = 'retreat'; ai.goal = [base.x, base.y]; ai.target = null; };
  if (ai.mode === 'retreat') { if (atBase && hpR > 0.92) ai.mode = 'move'; else return retreat(); }
  if (hpR < 0.28) {
    retreat();
    const pot = u.items.findIndex((it) => it && it.id === 'jinchuang');
    if (pot >= 0 && u.st.regen <= 0) u.input.item = pot;
    const st = u.spec.skills.findIndex((s, i) => s.arch === 'stealth' && u.skillLv[i] && u.cd[i] <= 0);
    if (st >= 0) u.input.skill = { i: st };
    return;
  }
  const ebase = M.bases[1 - u.team];
  const foes = w.units.filter((t) => t.kind === 'hero' && w.isEnemy(u, t) && gd(u, t) < 700 && Math.hypot(t.x - ebase.x, t.y - ebase.y) > M.shopR + 60); // 不追進敵方溫泉
  let best = null, bs = 1e9;
  for (const t of foes) {
    if (underEnemyTower(w, u, t.x, t.y) && t.hp / t.maxHp > 0.25) continue;
    const s = gd(u, t) + (t.hp / t.maxHp) * 400 - (t.seal ? 300 : 0) - (w.hardCC(t) ? 250 : 0); // 集火被控住的敵人
    if (s < bs) { bs = s; best = t; }
  }
  const allies = w.heroes(u.team).filter((h) => h.alive && gd(h, u) < 700).length;
  if (best && (hpR > 0.45 || best.hp / best.maxHp < hpR) && (foes.length <= allies + 1 || hpR > 0.7)) { ai.mode = 'fight'; ai.target = best; return; }
  if (best && foes.length > allies + 1 && hpR < 0.6) return retreat();
  // 傳國玉璽在地上：夠近就去搶
  const seal = w.seal;
  if (seal.state === 'ground' && seal.unit && hpR > 0.5 && SG.gd(u.x, u.y, seal.x, seal.y) < 1300) { if (SG.gd(u.x, u.y, seal.x, seal.y) < 500) { ai.mode = 'fight'; ai.target = seal.unit; } else { ai.mode = 'move'; ai.target = null; ai.goal = [seal.x, seal.y]; } return; } // 近了就普攻五下奪璽
  // 劫糧：敵方糧車在附近、又不在敵塔下
  const cart = w.units.find((c) => c.kind === 'cart' && w.isEnemy(u, c) && gd(u, c) < (ai.lane === 'jungle' || ai.lane === 'bot' ? 1400 : 700) && !underEnemyTower(w, u, c.x, c.y));
  if (cart) { if (gd(u, cart) < 500) { ai.mode = 'fight'; ai.target = cart; } else { ai.mode = 'move'; ai.target = null; ai.goal = [cart.x, cart.y]; } return; }
  if (ai.lane === 'jungle' && w.t > 25) {
    const camp = w.camps.filter((c) => c.c.side === u.team && c.units.some((x) => x.alive))
      .sort((a, b) => Math.hypot(a.c.x - u.x, a.c.y - u.y) - Math.hypot(b.c.x - u.x, b.c.y - u.y))[0];
    if (camp) {
      if (Math.hypot(camp.c.x - u.x, camp.c.y - u.y) < 400) { ai.mode = 'fight'; ai.target = camp.units.filter((x) => x.alive).sort((a, b) => a.hp - b.hp)[0]; return; }
      ai.mode = 'move'; ai.goal = [camp.c.x, camp.c.y]; ai.target = null; return;
    }
  }
  const creeps = w.units.filter((t) => t.kind === 'minion' && w.isEnemy(u, t) && gd(u, t) < 560 && !underEnemyTower(w, u, t.x, t.y));
  const deny = foes.length && w.units.find((m) => w.canDeny(u, m) && gd(u, m) < 300);
  if (deny && SG.rand() < 0.5) { ai.mode = 'fight'; ai.target = deny; return; }
  if (creeps.length) { ai.mode = 'fight'; ai.target = creeps.sort((a, b) => a.hp - b.hp)[0]; return; }
  const tower = w.units.find((t) => t.structure && w.isEnemy(u, t) && t.team < 2 && !w.structureLocked(t) && gd(u, t) < 650);
  if (tower && w.units.some((m) => m.kind === 'minion' && m.team === u.team && m.alive && gd(m, tower) < tower.range)) { ai.mode = 'fight'; ai.target = tower; return; }
  const eb = w.units.find((b) => b.kind === 'base' && b.team !== u.team);
  if (eb && eb.alive && !w.structureLocked(eb)) {
    const near = w.heroes(u.team).filter((h) => h.alive && gd(h, eb) < 900).length;
    if (near >= 2 && gd(u, eb) < 900) { ai.mode = 'fight'; ai.target = eb; return; }
    // 集結到已經打穿的那一路
    const open = ['mid', 'top', 'bot'].find((ln) => w.units.some((t) => t.kind === 'tower' && !t.alive && t.team !== u.team && t.lane === ln && t.tier === 3)) || 'mid';
    ai.mode = 'move'; ai.target = null; ai.goal = laneFront(w, u, open); return;
  }
  ai.mode = 'move'; ai.target = null;
  ai.goal = laneFront(w, u, ai.lane === 'jungle' ? 'mid' : ai.lane);
}

function tick(w, u, dt) {
  if (!(w.fillT > w.t)) { w.fillT = w.t + 1; refill(w); } // 每秒看一次要不要補位
  const ai = u.ai, I = u.input, t = ai.target;
  ai.t -= dt;
  if (ai.t <= 0) { ai.t = 0.25 + SG.rand() * 0.1; if (!u.act) decide(w, u); }
  // 追蹤目標速度，技能預判用
  if (t) { if (ai.tp && ai.tpId === t.id) ai.tv = [(t.x - ai.tp[0]) / dt, (t.y - ai.tp[1]) / dt]; ai.tp = [t.x, t.y]; ai.tpId = t.id; }
  I.attack = false; I.defend = false;
  if (ai.mode === 'fight' && t && t.alive && (t.team === 2 || w.isEnemy(u, t) || w.canDeny(u, t))) {
    I.moveTo = null; I.target = t;
    if (!u.act && !I.skill && SG.rand() < 0.12) {
      const i = [3, 0, 1, 2].find((k) => useful(w, u, k, t));
      if (i !== undefined) {
        const lead = 0.35 * ai.skill, err = (1 - ai.skill) * 60;
        I.skill = { i, x: t.x + ai.tv[0] * lead + (SG.rand() - 0.5) * err, y: t.y + ai.tv[1] * lead + (SG.rand() - 0.5) * err * 0.7 };
      }
    }
    // 遠程武將被近戰貼身時，出手後退一步（風箏）
    if (u.ranged && t.kind === 'hero' && !t.ranged && gd(u, t) < 160 && u.atkCd > 0.25 && !u.act) {
      const d = SG.dirTo(t, u.x, u.y);
      I.target = null; I.moveTo = SG.along(u.x, u.y, d, 120);
    }
    return;
  }
  I.target = null;
  I.moveTo = ai.goal || null;
}

SG.AI = { assign, tick, fit, slotsOf };
